var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851",
    transform: "translate(0.709 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(0.291)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5,
    cy: 16,
    rx: 16,
    ry: 16.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33906",
    "data-name": "Path 33906",
    d: "M13.956-8.224A1.742,1.742,0,0,0,12.73-9.458,41.176,41.176,0,0,0,7.313-9.75a41.176,41.176,0,0,0-5.418.292A1.742,1.742,0,0,0,.669-8.224a18.278,18.278,0,0,0-.29,3.359,18.278,18.278,0,0,0,.29,3.359A1.716,1.716,0,0,0,1.895-.292,41.176,41.176,0,0,0,7.313,0,41.176,41.176,0,0,0,12.73-.292a1.716,1.716,0,0,0,1.226-1.214,18.278,18.278,0,0,0,.29-3.359A18.278,18.278,0,0,0,13.956-8.224ZM5.894-2.8V-6.927L9.519-4.865,5.894-2.8Z",
    transform: "translate(8.291 20.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCYoutube);
export default __webpack_public_path__ + "static/media/icon_c_youtube.b10a7f441aa092785ba1297696d3c1cb.svg";
export { ForwardRef as ReactComponent };